import type { ListProduct } from '@/queries/utils/mapProductFragmentToListProduct';

import type WarrantySelection from '../_steps/enums/WarrantySelection';
import getExtendedWarrantyId from './getExtendedWarrantyId';
import getExtendedWarrantySku from './getExtendedWarrantySku';
import getHasSelectedWarranty from './getHasSelectedWarranty';

export interface BuildWarrantyObjectProps {
  fbc: string | null;
  fbp: string | null;
  image_url: string | null | undefined;
  url: string;
  threeYearWarranty: ListProduct | undefined;
  twoYearWarranty: ListProduct | undefined;
  warrantySelection: WarrantySelection;
}

export interface WarrantyObject {
  currency: string;
  fbc: string | null;
  fbp: string | null;
  image_url: string | null | undefined;
  url: string;
  price: number | null | undefined;
  product_id: number | null;
  selectedWarranty: ListProduct | null | undefined;
  sku: string;
  variant: number | undefined;
  warrantySelection: WarrantySelection;
}

export default function buildWarrantyObject({
  twoYearWarranty,
  threeYearWarranty,
  warrantySelection,
  ...rest
}: BuildWarrantyObjectProps): WarrantyObject {
  const productId = getExtendedWarrantyId(warrantySelection);
  const warrantySku = getExtendedWarrantySku(warrantySelection) ?? '';
  const isTwoYearWarranty = getHasSelectedWarranty(
    warrantySku,
    twoYearWarranty,
  );
  const isThreeYearWarranty = getHasSelectedWarranty(
    warrantySku,
    threeYearWarranty,
  );
  let selectedWarranty = null;
  switch (true) {
    case isTwoYearWarranty:
      selectedWarranty = twoYearWarranty;
      break;
    case isThreeYearWarranty:
      selectedWarranty = threeYearWarranty;
      break;
  }
  return {
    currency: selectedWarranty?.price?.currencyCode ?? 'USD',
    price: selectedWarranty?.price?.amount,
    product_id: productId,
    selectedWarranty,
    sku: warrantySku,
    variant: selectedWarranty?.variants[0]?.productId,
    warrantySelection,
    ...rest,
  };
}
